import get from 'lodash/get';
import { GET_RESULTS_SUCCESS } from '../results/results';
import prestoTracker from 'src/modules/presto-tracker/prestoTrackerCreator';

const getReduxTokens = store => {
  const uniqueSearchToken = get(store.getState(), 'results.uniqueSearchToken');
  const impressionToken = get(store.getState(), 'joblistitem.impressionToken');

  return { uniqueSearchToken, impressionToken };
};

const isFirstSearch = uniqueSearchToken => {
  return !uniqueSearchToken;
};

const hasMissingImpression = (uniqueSearchToken, impressionToken) => {
  return uniqueSearchToken !== impressionToken;
};

const createMissingImpressionMiddleware = () => store => next => action => {
  if (typeof action === 'function') {
    return action(store.dispatch, store.getState);
  }
  const { uniqueSearchToken, impressionToken } = getReduxTokens(store);
  if (
    !isFirstSearch(uniqueSearchToken) &&
    action.type === GET_RESULTS_SUCCESS &&
    hasMissingImpression(uniqueSearchToken, impressionToken)
  ) {
    const loggingArguments = {
      actionType: 'missingImpression',
      uniqueSearchToken
    };
    prestoTracker({ data: loggingArguments });
  }

  return next(action);
};

export default createMissingImpressionMiddleware;
